module.exports = __webpack_public_path__ + "img/pptLogo1.19cb4628.png";